import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
		user: null,
		loading: false,
		error: null,
		year: null,
		myHcp: null,
		actualRoundKey: null,
		actualRound: null,
		lastFiveRounds: null,
		searchRounds: null
	},

	mutations: {
		setUser(state, payload) {
			state.user = payload
		},
		setLoading(state, payload) {
			state.loading = payload
		},
		setError(state, payload) {
			state.error = payload
		},
		clearError(state) {
			state.error = null
		},
		setYear(state, payload) {
			state.year = payload
		},
		myHcp(state, payload) {
			state.myHcp = payload
		},
		actualRoundKey(state, payload) {
			state.actualRoundKey = payload
		},
		actualRound(state, payload) {
			state.actualRound = payload
		},
		lastFiveRounds(state, payload) {
			state.lastFiveRounds = payload
		},
		searchRounds(state, payload) {
			state.searchRounds = payload
		}
		// End Mutations
	},

	actions: {
		login({ commit }) {
			commit('setLoading', true)
			commit('clearError')
			var provider = new firebase.auth.GoogleAuthProvider();
			firebase.auth().signInWithPopup(provider)
				.then(
				user => {
					commit('setLoading', false)
					var newUser = user.user
					commit('setUser', newUser)
				}
				)
				.catch(
				error => {
					commit('setLoading', false)
					commit('setError', error)
					console.log(error)
				}
				)
		},
		logout({ commit }) {
			firebase.auth().signOut()
			commit('setUser', null)
			commit('myHcp', null)
		},
		autoSignIn({ commit }, payload) {
			commit('setUser', payload)
		},
		setActualYear({ commit }) {
			var newDate = new Date()
			var options = { year: 'numeric' }
			var actualYear = newDate.toLocaleDateString('de-DE', options)
			commit('setYear', actualYear)
		},
		setHcp({ commit }, payload) {
			var uid = this.state.user.uid
			var name = this.state.user.displayName
			firebase.database().ref('users/' + uid).set({ name: name, hcp: payload });
		},
		fetchHcp({ commit }, payload) {
			var uid = payload.uid
			firebase.database().ref('users/' + uid + '/hcp').on('value', function (snapshot) {
				console.log('snapshot ' + snapshot.val())
				var tempHcp = snapshot.val()
				if (tempHcp !== null) {
					commit('myHcp', tempHcp)
				}
				else {
					console.log('error hcp')
				}
			})
		},
		newRoundYellow({ commit }) {
			if (this.state.user) {
				// Datum erzeugen
				var newDate = new Date();
				var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
				var date = newDate.toLocaleDateString('de-DE', options);

				// Keys für Round und Shortround erzeugen
				var newRoundKey = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').push().key;
				var newShortKey = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds').push().key;

				// In Database schreiben
				firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds').child(newShortKey).set({
					roundKey: newRoundKey,
					datum: date,
					farbe: "gelb",
					score: 0,
					points: 0
				});
				firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').child(newRoundKey).set({
					shortKey: newShortKey,
					datum: date,
					farbe: "gelb",
					hcp: this.state.myHcp,
					score1: 0,
					score2: 0,
					score3: 0,
					score4: 0,
					score5: 0,
					score6: 0,
					score7: 0,
					score8: 0,
					score9: 0,
					score10: 0,
					score11: 0,
					score12: 0,
					score13: 0,
					score14: 0,
					score15: 0,
					score16: 0,
					score17: 0,
					score18: 0
				});
			};
		},
		loadActualRoundKey({ commit }) {
			var ref = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds')
			ref.limitToLast(1).once('value', function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					commit('actualRoundKey', childSnapshot.key)
					store.dispatch('loadActualRound')
				});
			})
		},
		loadActualRound({ commit }) {
			commit('setLoading', true)
			var key = this.state.actualRoundKey
			var ref = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').child(key)
			ref.on('value', function (snapshot) {
				commit('actualRound', snapshot)
			})
			commit('setLoading', false)
		},
		editScore({ commit }, payload) {
			var ref = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').child(payload.key)
			var updates = {};
			var scoreKey = payload.loch
			updates[scoreKey] = payload.score;
			ref.update(updates)
		},
		updateShortround({ commit }, payload) {
			var shortRef = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds').child(payload.shortKey)
			shortRef.update({ score: payload.score, points: payload.points })
		},
		getLastRounds({ commit }) {
			var lastFiveRounds = []
			var ref = firebase.database().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds')
			ref.limitToLast(5).once('value', function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					lastFiveRounds.push(childSnapshot)
				})
				commit('lastFiveRounds', lastFiveRounds)
			})
		},
		setRound({ commit }, payload) {
			commit('actualRoundKey', payload.roundKey)
			store.dispatch('loadActualRound')
		},
		searchRounds({ commit }, payload) {
			commit('setLoading', true)
			var loadedRounds = []
			commit('searchRounds', loadedRounds)
			var ref = firebase.database().ref('users/' + this.state.user.uid + '/' + payload.year + '/shortrounds')
			ref.once('value', function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					loadedRounds.push(childSnapshot)
				})
				commit('searchRounds', loadedRounds)
				commit('setLoading', false)
			})
		},
		deleteRounds({ commit }, payload) {
			firebase.database().ref('users/' + this.state.user.uid + '/' + payload.year + '/shortrounds').child(payload.shortKey).remove()
			firebase.database().ref('users/' + this.state.user.uid + '/' + payload.year + '/rounds').child(payload.roundKey).remove()
			// var year = {year: payload.year}
			// store.dispatch('searchRounds', year)
		},
		deleteSearchRounds({ commit }) {
			var rounds = []
			commit('searchRounds', rounds)
		}





		// End Actions
	},

	getters: {
		user(state) {
			return state.user
		},
		year(state) {
			return state.year
		},
		loading(state) {
			return state.loading
		},
		error(state) {
			return state.error
		},
		myHcp(state) {
			return state.myHcp
		},
		actualRoundKey(state) {
			return state.actualRoundKey
		},
		actualRound(state) {
			return state.actualRound
		},
		lastFiveRounds(state) {
			return state.lastFiveRounds
		},
		searchRounds(state) {
			return state.searchRounds
		}

	}
})


// WEBPACK FOOTER //
// ./src/store/index.js